/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.optionSelectors = this.querySelectorAll('.option-selector:not(.option-selector--custom)');
      this.nativeSelector = document.getElementById(`variants-${this.section.dataset.section}`);
      this.data = this.getVariantData();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();

      // Added by OCS - For the Ancore & Mina launch those products have some issue in making fadeout for out of stock variants, so controlled this function excluding these 2 products on page load.
      const productTitleonLoad = document.querySelector('.product-title').textContent.trim().toLowerCase();
      if (productTitleonLoad !== "lunettes de soleil ancora" && productTitleonLoad !== "lunettes de soleil mina" && productTitleonLoad !== "sunglasses ancora" && productTitleonLoad !== "sunglasses mina"){
        this.updateAvailability();
      }
      this.updateAddToCartButton();
      this.addEventListener('change', this.handleVariantChange.bind(this));

      this.setAttribute('loaded', '');
    }

    isGiftCardProduct() {
      const isGiftCardFromDataset = this.section?.dataset?.isGiftCard === 'true'
        || this.productForm?.dataset?.isGiftCard === 'true';
      const templateSuffix = this.section?.dataset?.templateSuffix
        || this.productForm?.dataset?.templateSuffix
        || '';
      const isGiftCardFromTemplate = templateSuffix === 'e-carte-cadeau';
      return isGiftCardFromDataset || isGiftCardFromTemplate;
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();

      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      this.updateUrl(evt);
      this.updateVariantInput();
      this.updateAddToCartButton();
      
      // Added by OCS - For the Ancore & Mina launch those products have some issue in making fadeout for out of stock variants, so controlled this function excluding these 2 products on variant change.
      const productTitlehandleChage = document.querySelector('.product-title').textContent.trim().toLowerCase();
      if (productTitlehandleChage !== "lunettes de soleil ancora" && productTitlehandleChage !== "lunettes de soleil mina" && productTitlehandleChage !== "sunglasses ancora" && productTitlehandleChage !== "sunglasses mina"){
        this.updateAvailability();
      }
      this.updatePrice();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateVariantMetaField();
      this.notifyMe();
      this.updateSku();
      this.updateBarcode();
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          allVariants: this.data.variants,
          selectedOptions: this.selectedOptions
        }
      }));
    }

    /**
     * Updates the "Add to Cart" button label and status.
     */
    updateAddToCartButton() {
      if (!this.productForm) return;
      if (this.selectedOptions.indexOf(null) > -1) return;

      /* Commented by OCS - To change the button text based on the available date, preorder condition. */
      // const variantAvailable = this.variant && this.variant.available;
      // const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      // this.addBtn.disabled = !variantAvailable;
      // this.addBtn.textContent = variantAvailable
      //   ? this.addBtn.dataset.addToCartText
      //   : unavailableStr;

      /* Added by OCS - To display Avaialble date for the pre order based on conditions */
      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const selectedVariantId = this.variant && this.variant.id;
      const variantQuantity = $('.variant-quantity[data-variant-id="' + selectedVariantId + '"]').data('quantity');
      const preorderAvailableDate = $('.product-date_available[data-variant-id="' + selectedVariantId + '"]').data('dateavailable');
      const availableDateDiv = document.getElementById('preorder_available_date');
      const availableDateSpan = availableDateDiv.querySelector('span');
      const productTitleElement = document.querySelector('.product-title');
      const productTitle = productTitleElement.textContent.trim().toLowerCase();

      const siteLanguage = Shopify.locale || 'en';
      const texts = {
        en: {
          notify: "Notify Me",
          addToCart: "Add to Cart",
          reserve: "Reserve now",
          soldout: "Out of stock"
        },
        fr: {
          notify: "Me Notifier",
          addToCart: "Ajouter au Panier",
          reserve: "Réserver maintenant",
          soldout: "Épuisé"
        }
      };

      const isGiftCard = this.isGiftCardProduct();
      const isTracked = !!(this.variant && this.variant.inventory_management);
      const shouldUseOcsStockRules = !isGiftCard && isTracked;

      // Added by OCS - Lecture du metafield custom.out_of_stock (product-level) depuis le data attribute
      const outOfStockForce = this.section && this.section.dataset.outOfStock === '1';

      const hasPreorderDate = preorderAvailableDate != null && preorderAvailableDate !== '' && preorderAvailableDate !== 'none';
      const formattedDate = (() => {
        if (!hasPreorderDate) return '';
        const dateParts = String(preorderAvailableDate).split('/');
        if (dateParts.length !== 3) return String(preorderAvailableDate);
        return `${parseInt(dateParts[1])}/${parseInt(dateParts[0])}/${dateParts[2]}`;
      })();

      if (availableDateSpan) {
        availableDateSpan.innerHTML = formattedDate;
      }

      if (availableDateDiv) {
        availableDateDiv.style.display = (shouldUseOcsStockRules && variantQuantity < 3 && hasPreorderDate) ? 'block' : 'none';
      }

      if (shouldUseOcsStockRules && variantQuantity < 3 && hasPreorderDate) {
        // Cas précommande : date de dispo renseignée → bouton "Notify Me" + bloc notify
        if (availableDateDiv) availableDateDiv.style.display = 'block';
        this.addBtn.textContent = texts[siteLanguage]?.notify || texts['en'].notify;
        this.addBtn.setAttribute('data-add-to-cart-text', texts[siteLanguage]?.notify || texts['en'].notify);
      } else if (shouldUseOcsStockRules && variantQuantity < 3 && !hasPreorderDate && outOfStockForce) {
        // Cas out_of_stock forcé : stock < 3, pas de date, custom.out_of_stock = 1
        // → bouton "Sold Out" désactivé, pas de bloc "Notify Me"
        if (availableDateDiv) availableDateDiv.style.display = 'none';
        this.addBtn.disabled = true;
        this.addBtn.textContent = texts[siteLanguage]?.soldout || texts['en'].soldout;
        this.addBtn.setAttribute('data-add-to-cart-text', texts[siteLanguage]?.soldout || texts['en'].soldout);
      } else {
        const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
        const addText = texts[siteLanguage]?.addToCart || texts['en'].addToCart;

        this.addBtn.disabled = !variantAvailable;
        this.addBtn.textContent = variantAvailable ? addText : unavailableStr;
        this.addBtn.setAttribute('data-add-to-cart-text', addText);
      }
    }

    /**
     * Notify Me related updates.
     */
    // Added by OCS
    notifyMe() {
      const selectedVariantId = this.variant && this.variant.id;
      const selectedVariantSku = this.variant && this.variant.sku;
      const variantQuantity = $('.variant-quantity[data-variant-id="' + selectedVariantId + '"]').data('quantity');
      const preorderAvailableDate = $('.product-date_available[data-variant-id="' + selectedVariantId + '"]').data('dateavailable');
      
      const buyButtonsDiv = document.querySelector('.buy-buttons-row');
      const notifyMeContainer = document.querySelector('.mailalert-container');
      const notifyEmail = document.getElementById('notify_emails');
      const notifyVariantId = document.getElementById('variant-id');
      const notifyVariantSku = document.getElementById('variant-sku');

      const productTitleElement = document.querySelector('.product-title');
      const productTitle = productTitleElement.textContent.trim().toLowerCase();

      if (buyButtonsDiv) {
        const isGiftCard = this.isGiftCardProduct();
        const isTracked = !!(this.variant && this.variant.inventory_management);
        const shouldUseOcsStockRules = !isGiftCard && isTracked;
        const hasPreorderDate = preorderAvailableDate != null && preorderAvailableDate !== '' && preorderAvailableDate !== 'none';
        // Added by OCS - Lecture du metafield custom.out_of_stock (product-level)
        const outOfStockForce = this.section && this.section.dataset.outOfStock === '1';

        if (productTitle === "lunettes de soleil ancora" ||  productTitle === "lunettes de soleil mina" ||  productTitle === "sunglasses ancora" ||  productTitle === "sunglasses mina") {
          // Exception produits Ancora & Mina : toujours afficher bouton d'achat
          buyButtonsDiv.classList.remove('hide_buy_buttons');
          notifyMeContainer.classList.add('hide_notify_me');
        } else if (shouldUseOcsStockRules && variantQuantity < 3 && hasPreorderDate) {
          // Cas précommande : masquer bouton d'achat, afficher bloc "Notify Me"
          buyButtonsDiv.classList.add('hide_buy_buttons');
          notifyMeContainer.classList.remove('hide_notify_me');
        } else if (shouldUseOcsStockRules && variantQuantity < 3 && !hasPreorderDate && outOfStockForce) {
          // Cas out_of_stock forcé : afficher bouton d'achat (Sold Out), masquer bloc "Notify Me"
          buyButtonsDiv.classList.remove('hide_buy_buttons');
          notifyMeContainer.classList.add('hide_notify_me');
        } else {
          buyButtonsDiv.classList.remove('hide_buy_buttons');
          notifyMeContainer.classList.add('hide_notify_me');
        }
      }

      notifyEmail.value = "";
      notifyVariantId.value = selectedVariantId;
      notifyVariantSku.value = selectedVariantSku;
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMode } = this.dataset; // 'down' or 'selection'
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      const updateOptionAvailability = (optionEl, exists, available) => {
        const el = optionEl;
        const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
        el.classList.toggle('is-unavailable', !available);
        el.classList.toggle('is-nonexistent', !exists);

        if (optionEl.classList.contains('custom-select__option')) {
          const em = el.querySelector('em');

          if (em) {
            em.hidden = available;
          }

          if (!available) {
            if (em) {
              em.textContent = unavailableText;
            } else {
              el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
            }
          }
        } else if (!available) {
          el.nextElementSibling.title = unavailableText;
        } else {
          el.nextElementSibling.removeAttribute('title');
        }
      };
// Added by OCS - Prend en compte le flag out_of_stock forcé pour griser les vignettes
const outOfStockForce = this.section && this.section.dataset.outOfStock === '1';
const isGiftCard = this.isGiftCardProduct();

const getEffectiveAvailability = (v) => {
  if (!v.available) return false;
  if (isGiftCard) return true;

  const isTracked = !!v.inventory_management;
  if (!isTracked) return true;

  const qty = $('.variant-quantity[data-variant-id="' + v.id + '"]').data('quantity');
  const preorderDate = $('.product-date_available[data-variant-id="' + v.id + '"]').data('dateavailable');
  const hasPreorderDate = preorderDate != null && preorderDate !== '' && preorderDate !== 'none';

  if (outOfStockForce && qty < 3 && !hasPreorderDate) return false;

  return true;
};
      if (availabilityMode === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.variants.forEach((v) => {
              let matchesSelectedAbove = selectorIndex < 1;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matchesSelectedAbove = true;
                }
              }
              if (v.options[selectorIndex] === optionValue && matchesSelectedAbove) {
                variantsExist = true;
                if (getEffectiveAvailability(v)) {
  variantsAvailable = true;
}
              }
            });
            updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default') ? '' : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the colour option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability = this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-price .price');
      if (!this.price) return;

      let { variant } = this;
      if (this.preSelection) {
        variant = this.data.variants[0];
        for (let i = 1; i < this.data.variants.length; i += 1) {
          if (this.data.variants[i].price < variant.price) variant = this.data.variants[i];
        }
      }

      if (variant) {
        //const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        

        // Update current price and original price if on sale.
        //priceCurrentEl.innerHTML = this.data.formatted[variant.id].price;
        
        //Added by ocs to remove values of ,00
        const priceCurrentEl = this.price.querySelector('.price__current');
        let formattedPrice = this.data.formatted[variant.id].price;
        formattedPrice = formattedPrice.replace(',00', '');
        priceCurrentEl.innerHTML = formattedPrice;
     
// Added by ocs pour enlever ,00 sur le prix barré
if (priceWasEl) {
  let formattedCompare = this.data.formatted[variant.id].compareAtPrice || '';
  formattedCompare = formattedCompare.replace(',00', ' ');
  priceWasEl.innerHTML = formattedCompare;
}

        if (priceWasEl) priceWasEl.innerHTML = this.data.formatted[variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = variant.unit_price_measurement.reference_value;
          const unit = variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
          unitPriceEl.hidden = false;
        } else if (unitPriceEl) {
          unitPriceEl.hidden = true;
        }

        this.price.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
        this.price.classList.toggle('price--sold-out', !variant.available && !this.preSelection);
      }

      this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
      this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }
    }


    /**
     * Updates the Variant Lens Color Metafield.
     */
    // Added by OCS
    updateVariantMetaField() {
      const selectedVariantId = this.variant && this.variant.id;
      const metafieldValue = $('.variant-metafield[data-variant-id="' + selectedVariantId + '"]').data('metafield');
      const variantMetaContainer = document.getElementById('selected-variant-metafield');
      const variantMetaSpan = document.getElementById('couleur-verre-value');
    
      if (variantMetaContainer && variantMetaSpan) {
        if (metafieldValue) {
          variantMetaSpan.innerHTML = metafieldValue;
          variantMetaContainer.style.display = 'block';
        } else {
          variantMetaContainer.style.display = 'none';
        }
      }
    }
    
    
    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcode = this.barcode || this.section.querySelector('.product-barcode__value');
      if (!this.barcode) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
      this.barcode.parentNode.hidden = !barcodeAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      const url = this.variant ? `${this.dataset.url}?variant=${this.variant.id}` : this.dataset.url;
      window.history.replaceState({ }, '', url);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms = this.forms || this.section.querySelectorAll('.js-product-form, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('[name="id"]');
        input.value = this.variant ? this.variant.id : '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the variant data for a product.
     * @returns {?object}
     */
    getVariantData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get the selected values from a list of variant options.
     * @returns {Array} Array of selected option values, value is null if not selected.
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
          selectedOptions.push(selected && selected.dataset.value !== '' ? selected.dataset.value : null);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      return this.data.variants.find(
        (v) => v.options.every((val, index) => val === this.selectedOptions[index])
      );
    }
  }

  customElements.define('variant-picker', VariantPicker);
}